// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xR5j","badges":"styles_badges__1q9aB"};